module.exports = __webpack_public_path__ + "static/media/DubaiW23-Medium.0e20868c.woff";